import type { Point } from '@ardoq/math';

export const calculateOffsetInDeg = (componentsCount: number): number => {
  const offsetInDegrees =
    componentsCount % 2 === 1 ? 90 : 90 - 180 / componentsCount;
  return offsetInDegrees;
};

export const getAngle = (index: number, count: number) => {
  const offsetInDegrees = calculateOffsetInDeg(count);
  const offsetInRad = (offsetInDegrees * Math.PI) / 180;
  return (index / count) * 2 * Math.PI + offsetInRad;
};
/** @param angle in radians. */
export const getPoint = (angle: number, radius: number): Point => [
  Math.cos(angle) * radius,
  Math.sin(angle) * radius,
];
